import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-associarsi',
  templateUrl: './associarsi.component.html',
  styleUrls: ['./associarsi.component.css']
})
export class AssociarsiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
